<template>
    <div>
        <div class="bax-or-divider"></div>
    </div>
</template>

<script>
export default {
    name: 'VueDivider',
};
</script>
